<template>
<div class="chapter">
<div class="inner_page">
<div class="pagebreak">
</div>
<h1 class="tocchaptitle"><a id="book1"></a>WHAT IS THIS BOOK ALL ABOUT?</h1>
<p class="text"><big>J</big>ust as bridges must be built between cultures and countries, so too must bridges be built to span the distance between the great wisdom teachings of centuries past and our own times. L<i>et</i> G<i>o and</i> L<i>ive in the</i> N<i>ow</i> is such a bridge. Its gentle but sometimes shocking revelations reach right into the mind of the seeker of the higher life, filling it with a palpable new light that helps bridge the distance between who we are at present and what we may yet become.</p>
<p class="textindent">Each chapter is filled with timeless principles presented in a current context. These principles are made practical and are empowered by the numerous ways in which the author suggests their application to modern-day life. Much more than just a set of “how to” instructions, this is a book whose thought-provoking stories and penetrating insights work directly upon the heart of the reader, to help start the internal process of self-healing.</p>
<p class="textindent">L<i>et</i> G<i>o and</i> L<i>ive in the</i> N<i>ow</i> is a living example of the timeless wholeness to which it leads its reader. It is gentle and striking, urgent and restive, serious and light-hearted. This book is for any person who longs not just to discover the truth of themselves, but who wishes to become a conscious participant in the great transformation of our Living Universe.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06-bookabout.vue?5d62d8af